import { graphql } from "gql.tada";

export const ConfigMoveMut = graphql(`
  mutation repositionConfiguration($input: RepositionConfigurationInput) {
    repositionConfiguration(input: $input)
  }
`);
